export default "__VITE_ASSET__DcpV0ZcB__"